// extracted by mini-css-extract-plugin
module.exports = {"swiper-carousel":"swiper-carousel_swiper-carousel__24OgI"};